import { render, staticRenderFns } from "./ShopInfoView.vue?vue&type=template&id=3a71d250&"
import script from "./ShopInfoView.vue?vue&type=script&lang=js&"
export * from "./ShopInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports